import po from './po-config'

export const search = { inputs: po.search.inputs.slice(0, 11), lines: [] }

search.inputs[0] = {
  type: 'InputSelect',
  title: 'Type',
  span: 6,
  options: 'getters/search/blPageTypeAll',
  getter: 'state/search/orderType',
  setter: 'commit/search/setOrderType',
  defaultValue: 4
}

search.inputs[2] = {
  type: 'InputDateRangePicker',
  title: 'Due Date',
  span: 6,
  getter: 'state/search/dueDateRange',
  setter: 'commit/search/setDueDateRange'
}

search.inputs[3] = {
  type: 'InputSelect',
  title: 'TAG',
  span: 6,
  options: 'getters/search/purchaseTagsWithAll',
  getter: 'state/search/tag',
  setter: 'commit/search/setTag',
  defaultValue: 0
}

search.inputs.push({
  type: 'InputSelect',
  title: 'Xero Sent',
  span: 6,
  options: 'getters/search/xeroSends',
  getter: 'state/search/xeroSend',
  setter: 'commit/search/setXero',
  defaultValue: 0
})

search.lines = [
  ...po.search.lines.slice(0, 11),
  {
    prop: 'xeroSent',
    label: 'XeroSent',
    align: 'center',
    width: 90
  },
  {
    prop: 'ColumnShow',
    label: 'is Paid',
    getter: 'actualPayType',
    trans: 'getters/getBillPayName',
    width: 60,
    className: 'table-column-list-isPaid-gray'
  },
  {
    ...po.search.lines[po.search.lines.length - 1]
  }
]

search.lines[8] = {
  prop: 'ColumnShow',
  label: 'Due Date',
  getter: 'dueDate',
  trans: 'getters/dateFormatAu',
  align: 'center',
  width: 100
}

export const edit = {
  inputs: [
    {
      type: 'InputTagWithOrderType',
      title: 'TAG',
      span: 24,
      placeholder: 'Select',
      options: 'getters/purchaseTags',
      getter: 'state/edit/tagId',
      setter: 'commit/edit/setTag',
      width: 200
    },
    ...po.edit.inputs.slice(1, 5),
    {
      type: 'InputDatePicker',
      title: 'Due Date',
      span: 6,
      getter: 'state/edit/dueDate',
      setter: 'commit/edit/setDueDate',
      width: 200
    },
    ...po.edit.inputs.slice(6)
  ],
  lines: po.edit.lines.slice() }

export const draft = {
  inputs: [
    ...po.draft.inputs.slice(0, 7),
    {
      type: 'InputShow',
      title: 'Due Date',
      span: 6,
      getter: 'state/edit/dueDate',
      trans: 'getters/dateFormatAu',
      labelClass: 'detail-text-strong'
    },
    ...po.draft.inputs.slice(8)
  ],
  lines: po.draft.lines.slice()
}
export default { search, edit, draft, approve: { inputs: draft.inputs.slice(), lines: draft.lines.slice() } }
